module.exports = " <div _v-81d48ca0=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-81d48ca0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/logout.vue
// module id = 484
// module chunks = 2